/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../User/User.css";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import { toastEmmit } from "../../../../Helper/Toastr";
import { format } from "date-fns";
import MoonLoader from "react-spinners/MoonLoader";
import Pagination from "../../../../Helper/Pagination";
import Switch from "@mui/material/Switch";
import defaultImg from "../../../../assets/img/no_user.jpg";

import {
  showSuccessAlert,
  showErrorAlert,
  showDeleteConfirmation,
} from "../../../../Helper/SweetAlert";

export default function User() {
  const [userData, setUserData] = useState();
  const [totalPages, setTotalPages] = useState();
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [S_No_Count, setCount] = useState(1);
  const [id, setId] = useState();
  const [userLimit, setUserLimit] = useState(10);
  const [sorting, setSorting] = useState("sortingKey|desc");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedState, setselectedState] = useState("");

  useEffect(() => {
    getUserList();
  }, [search, currentPage]);

  const getUserList = async () => {
    setLoading(true);
    const data = {
      limit: userLimit,
      sorting: sorting,
      page: currentPage,
      search_key: search,
    };
    PostService(API_URL.GET_ALL_USER, data).then(
      (res) => {
        console.log(res);
        if (res.data.status === true) {
          setUserData(res.data.data.rows);
          setTotalPages(res.data.totalPages);
          setTotal(res.data.totalItems);
          setLoading(false);
        } else {
          showErrorAlert(res.data?.message);
          setLoading(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setLoading(false);
      }
    );
  };

  function deleteuser(user_id, name) {
    const id = {
      id: user_id,
    };

    showDeleteConfirmation(name, () => {
      PostService(API_URL.DELETE_USER, id).then(
        (res) => {
          if (res.data.status) {
            showSuccessAlert(res?.data?.message, getUserList);
          } else {
            showErrorAlert(res.data?.message);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
        }
      );
    });
  }

  const changeStatus = async (userId, status) => {
    const data = {
      id: userId,
      status: status === "active" ? "inactive" : "active",
    };

    PostService(API_URL.CHANGE_USER_STATUS, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(res?.data?.message, getUserList);
        } else {
          showErrorAlert(res.data?.message, getUserList);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message, getUserList);
      }
    );
  };

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Users List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">Users list</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row px-3">
                    <div className="col-md-4 offset-md-8 p-0">
                      <nav className="navbar p-0">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setSearch(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                    <div class="table-responsive mt-4">
                      {!loading && (
                        <table class="table table-hover table-bordered table-striped">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Profile</th>
                              <th>User Name</th>
                              <th>Email</th>
                              <th>Country</th>
                              <th>Created At</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {userData &&
                              userData?.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + currentPage * userLimit + 1}</td>
                                  <td>
                                    <div className="user-profile-container">
                                      <img
                                        src={item?.profile ? item?.profile : ""}
                                        alt=""
                                        onError={(e) => {
                                          e.target.src = defaultImg;
                                        }}
                                        className="user-profile-image"
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    {item?.fname && item?.lname && (
                                      <span>
                                        {item?.fname} {item?.lname}
                                      </span>
                                    )}
                                    {!item?.fname && !item?.lname && (
                                      <span>{item?.fullName || "N/A"}</span>
                                    )}
                                  </td>
                                  <td>{item?.email}</td>
                                  <td>
                                    {item?.country
                                      ? item?.country
                                      : item?.country_id
                                      ? item?.country_id
                                      : "N/A"}
                                  </td>
                                  <td>
                                    {item?.createdAt
                                      ? format(
                                          new Date(item?.createdAt),
                                          "dd/MM/yyyy"
                                        )
                                      : "N/A"}
                                  </td>
                                  <td>
                                    <label
                                      className={
                                        item?.status === "active"
                                          ? "badge badge-success"
                                          : "badge badge-danger"
                                      }
                                    >
                                      {item?.status === "active"
                                        ? "Active"
                                        : "Inactive"}
                                    </label>
                                  </td>
                                  <td>
                                    <span className="toggle-switch">
                                      <Switch
                                        checked={item?.status === "active"}
                                        onChange={() => {
                                          changeStatus(item.id, item.status);
                                        }}
                                        size="small"
                                        color="primary" // You can customize the color
                                        inputProps={{
                                          "aria-label": "toggle switch",
                                        }}
                                      />
                                    </span>

                                    <span
                                      title="view"
                                      style={{ cursor: "pointer" }}
                                      className="mx-2"
                                      data-toggle="modal"
                                      data-target="#ViewModal"
                                      onClick={() => {
                                        setselectedState(item);
                                      }}
                                    >
                                      <i className="text-warning fas fa-eye"></i>{" "}
                                    </span>
                                    <span
                                      title="Delete"
                                      style={{ cursor: "pointer" }}
                                      className="mx-2"
                                      // data-toggle="modal"
                                      // data-target="#DeleteModal"
                                      onClick={() => {
                                        deleteuser(item?.id, "User");
                                      }}
                                    >
                                      <i className="text-danger fas fa-trash"></i>{" "}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            {userData && userData.length === 0 && (
                              <tr>
                                <td colSpan="7" className="text-center">
                                  <h6 className="p-3"> No Data Found </h6>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}

                      {loading ? (
                        <div className="LoaderSpinner">
                          <MoonLoader
                            color={"#003bff"}
                            loading={loading}
                            speedMultiplier={0.6}
                            size={50}
                          />
                          <div>Loading... Please wait.</div>
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="mt-4">
                        <Pagination
                          counting={currentPage * userLimit}
                          totaldata={total}
                          pagecount={totalPages}
                          onChangePage={handlePageClick}
                          activePage={currentPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* / View MODAL-------------------- / */}
      <div
        className="modal fade"
        id="ViewModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-light">
              <h4 className="modal-title" id="exampleModalLabel">
                View User
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="mt-3">
              <div className="row offset-md-1 mb-3">
                <div className="col-md-4">
                  <label>Profile :</label>
                </div>
                <div className="col-md-8 overflow-hidden">
                  <img
                    src={selectedState?.profile ? selectedState?.profile : ""}
                    alt=""
                    onError={(e) => {
                      e.target.src = defaultImg;
                    }}
                    style={{
                      maxHeight: "150px",
                      maxWidth: "100%",
                      borderRadius: "10%",
                    }}
                  />
                </div>
              </div>
              <div className="row offset-md-1">
                <div className="col-md-4">
                  <label>User Name :</label>
                </div>
                <div className="col-md-8 ">
                  <p>
                    {selectedState?.fname && selectedState?.lname && (
                      <span>
                        {selectedState?.fname} {selectedState?.lname}
                      </span>
                    )}
                    {!selectedState?.fname && !selectedState?.lname && (
                      <span>{selectedState?.fullName || "N/A"}</span>
                    )}
                  </p>
                </div>
              </div>

              <div className="row offset-md-1">
                <div className="col-md-4">
                  <label>Email :</label>
                </div>
                <div className="col-md-8 ">
                  <p>{selectedState?.email || "N/A"}</p>
                </div>
              </div>
              <div className="row offset-md-1">
                <div className="col-md-4">
                  <label>Country :</label>
                </div>
                <div className="col-md-8 ">
                  <p>
                    {selectedState?.country
                      ? selectedState?.country
                      : selectedState?.country_id
                      ? selectedState?.country_id
                      : "N/A"}
                  </p>
                </div>
              </div>
              <div className="row offset-md-1">
                <div className="col-md-4">
                  <label>Contact No :</label>
                </div>
                <div className="col-md-8 ">
                  <p>{selectedState?.phone ? selectedState?.phone : "N/A"}</p>
                </div>
              </div>
              <div className="row offset-md-1">
                <div className="col-md-4">
                  <label>Status :</label>
                </div>
                <div className="col-md-8 ">
                  <p className="text-capitalize">{selectedState?.status}</p>
                </div>
              </div>
              <div className="row offset-md-1">
                <div className="col-md-4">
                  <label>Created At :</label>
                </div>
                <div className="col-md-8 ">
                  <p className="text-capitalize">
                    {selectedState?.createdAt
                      ? format(new Date(selectedState?.createdAt), "dd/MM/yyyy")
                      : "N/A"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* / View MODAL- End ------------------- / */}

      {/* / DELETE MODAL-------------------- / */}
      <div
        className="modal fade"
        id="DeleteModal"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header bg-light">
              <h5 className="modal-title" id="exampleModalLabel">
                Delete User !
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <h6> Are you sure you want to delete this User ? </h6>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                id="closeDeleteModal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                // onClick={() => deleteuser()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* / DELETE MODAL- End ------------------- / */}
    </div>
  );
}
